import * as ReactQuery from "@tanstack/react-query";
import { MutationOption, queryClient } from "libs/react-query";
import * as Brm from "services/brm";
import * as KeyFactory from "./project-query-key-factory";

interface IAddProjectWorkerProps {
  projectId: string;
  userId: any;
}

/**
 * Add a project readonly worker
 *
 * @returns
 */
export const addProjectReadOnlyUser = ({ projectId, userId }: IAddProjectWorkerProps) => {
  return projectId === null
    ? Promise.reject(new Error("Invalid projectId id"))
    : Brm.projectApi.addProjectReadonly(projectId, { body: userId });
};

interface ICreateProjectQueryProps {
  options?: MutationOption<typeof addProjectReadOnlyUser>;
}

/**
 * Custom hook to add a project readonly worker
 *
 * @returns react-query Mutation.
 */
export const useAddProjectReadOnlyUser = ({ options }: ICreateProjectQueryProps = {}) => {
  return ReactQuery.useMutation({
    onSettled: (data, context, variables) => {
      queryClient.invalidateQueries(KeyFactory.projectKeys.readOnlyUsers(variables.projectId));
    },
    ...options,
    mutationFn: addProjectReadOnlyUser,
  });
};
